import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContent,[_c(VContainer,{attrs:{"justify":"center"}},[_c(VRow,[_c(VCol,{class:_vm.$style.pageTitle},[_vm._v(" "+_vm._s(_vm.$t('pages.notFoundPage.message.pageNotFound'))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }